import { Box, Divider, Paper, Typography } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";

import { amazonColors } from "../../../config/amazonTheme";

interface ProductAboutSectionProps {
  features: string[];
}

const ProductAboutSection: React.FC<ProductAboutSectionProps> = ({
  features,
}) => {
  const { t } = useTranslation();

  if (!features || features.length === 0) return null;

  return (
    <Box sx={{ mt: 6, mb: 4 }}>
      <Paper
        elevation={0}
        sx={{
          p: 4,
          border: `1px solid ${amazonColors.gray[200]}`,
          borderRadius: 2,
          backgroundColor: "#fff",
        }}
      >
        <Typography
          variant="h4"
          sx={{
            mb: 3,
            fontWeight: 700,
            color: amazonColors.text.primary,
            fontSize: "1.5rem",
            borderBottom: `2px solid ${amazonColors.blue}`,
            pb: 1,
            display: "inline-block",
          }}
          className="notranslate"
          translate="no"
        >
          {t("products.aboutThisItem")}
        </Typography>

        <Box sx={{ mt: 4 }}>
          {features.map((feature: string, index: number) => (
            <Box key={index} sx={{ mb: 3 }}>
              <Box sx={{ display: "flex", alignItems: "flex-start", gap: 2 }}>
                <Box
                  sx={{
                    width: 6,
                    height: 6,
                    borderRadius: "50%",
                    backgroundColor: amazonColors.blue,
                    mt: 1.5,
                    flexShrink: 0,
                  }}
                />
                <Typography
                  variant="body1"
                  sx={{
                    color: amazonColors.text.primary,
                    lineHeight: 1.7,
                    fontSize: "1rem",
                    fontWeight: 400,
                    textAlign: "justify",
                  }}
                >
                  {feature}
                </Typography>
              </Box>
              {index < features.length - 1 && (
                <Divider
                  sx={{
                    mt: 2,
                    borderColor: amazonColors.gray[100],
                    opacity: 0.5,
                  }}
                />
              )}
            </Box>
          ))}
        </Box>
      </Paper>
    </Box>
  );
};

export default ProductAboutSection;
